import React from 'react';
import TextFieldIcon from '../../../../../assets/svg/e-calendar/text-field-icon.svg';
import { useFieldData } from '../reservation-form.utils';
import { useIntl } from 'react-intl';
import { FormField } from '@hilbi/web-common/components/hilbi-form';
import TextArea from '@hilbi/web-common/components/e-visits/text-area';

type DescriptionFieldProps = {
  name: string;
  placeholder?: string;
  disabled?: boolean;
};

const TextAreaField: React.FunctionComponent<DescriptionFieldProps> = ({
  name,
  placeholder,
  disabled,
}) => {
  const { formatMessage } = useIntl();
  const { value, setValue, error } = useFieldData(name);

  return (
    <FormField
      disabled={disabled}
      error={error ? formatMessage({ id: error }) : ''}
      icon={TextFieldIcon}
      placeholder={placeholder}
    >
      <TextArea
        style={{ resize: 'none' }}
        onChange={(e) => setValue(e.currentTarget.value)}
        value={value}
        name={name}
      />
    </FormField>
  );
};

export default React.memo(TextAreaField);
